import React from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import { Center, Group, Stack, Text } from '@mantine/core';
import Button from '../../components/elements/Button';

const ModalRedeem = ({ opened, onClose, voucherName, onRedeem }) => {
  return (
    <ModalWrapper isVisible={opened} onClose={onClose} title="Redeem Voucher">
      <Stack>
        <Text className="text-sm-medium">
          {' '}
          Are you sure want to redeem this voucher{' '}
          <Text span inherit className="text-sm-semibold">
            {voucherName}
          </Text>
          ?
        </Text>
        <Text style={{}}>
          Your point will be reduced by the amount of the voucher.
        </Text>
        <Group justify="space-between">
          <Button onClick={onClose} variant="error-beelajar">
            Cancel
          </Button>
          <Button onClick={onRedeem}>Redeem</Button>
        </Group>
      </Stack>
    </ModalWrapper>
  );
};

export default ModalRedeem;
